import PropTypes from 'prop-types';

const propTypes = {
  datasetId: PropTypes.number.isRequired,
};

const defaultProps = {};

const DatasetTableData = ({ datasetId }) => <div>todo {datasetId}</div>;

DatasetTableData.propTypes = propTypes;
DatasetTableData.defaultProps = defaultProps;

export { DatasetTableData };
